import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import withIntl from "../../utils/withIntl";

function SearchBox(props) {
  return (
    <TextField
      style={{ margin: 10, width: "calc(100% - 20px)" }}
      value={props.searchValue}
      onKeyDown={(e) => {
        e.nativeEvent.stopImmediatePropagation();
      }}
      onChange={(e) => {
        props.onChange(e.target.value);
      }}
      size="small"
      label={props.intl.formatMessage({ id: "search" })}
      variant="outlined"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment:
          props.searchValue.length > 0 ? (
            <InputAdornment position="end">
              <ClearIcon
                onClick={() => {
                  props.onChange("");
                }}
              />
            </InputAdornment>
          ) : null,
      }}
    />
  );
}

SearchBox.propTypes = {
  searchValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withIntl(SearchBox);
